const steps = ["등록", "입문", "작업중", "작업완료", "출문"];
const stepsColor = ["#00CFE8", "#FF9F43", "#EA5455", "#28C76F", "#3C3C3C"];
const getUsers = (value) => {
  const qr_reads = value.qr_reads;
  const body = JSON.parse(value.post_content).body;
  const users = body.운전자정보;

  if (users) {
    // qr_reads 에 입문, 출문을 체크 하여 users 에 데이터를 넣어준다.
    const new_users = users.map((user) => {
      let 입문시간 = user.입문시간;
      let 출문시간 = user.출문시간;
      // qr_reads 에서 users 의 정보만 가져온다.
      const userQrs = qr_reads.filter((qr_read) => `${qr_read.user_id}` === `${user.userId}`);

      if (userQrs.length > 0) {
        for (const qr of userQrs) {
          // qr.created_at 예시 : 2024-11-08 22:03:17
          const createdAt = new Date(qr.created_at);

          // qr.data === '입문' 이고, createdAt 값이 가장 작은 값이 입문시간
          if (qr.data === "입문") {
            if (!입문시간 || 입문시간 === "" || new Date(입문시간) > createdAt) {
              입문시간 = qr.created_at;
            }
          }

          // qr.data === '출문' 이고, createdAt 값이 가장 큰 값이 출문시간
          if (qr.data === "출문") {
            if (!출문시간 || 출문시간 === "" || new Date(출문시간) < createdAt) {
              출문시간 = qr.created_at;
            }
          }
        }
      }

      return {
        ...user,
        입문시간,
        출문시간,
      };
    });

    return new_users;
  }

  return [];
};
const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-keyword",
        label: "사업장명",
        value: "사업장명",
        query: { fil_1: "keyword" },
        options: {
          default: "",
        },
      },
      {
        component: "search-start-end",
        label: "작업시작일",
        value: "date",
        query: { ss: "startDate", ee: "endDate" },
        options: {
          default: { sd: "", ed: "" },
        },
      },
      {
        component: "search-keyword",
        label: "허가번호",
        value: "허가번호",
        query: { fil_2: "keyword" },
        options: {
          default: "",
        },
      },
      {
        component: "search-select",
        label: "진행상태",
        value: "상태",
        query: { s1: "select" },
        options: {
          items: ["전체", "등록", "작업중", "작업완료"],
          default: "",
        },
      },
      {
        component: "search-select",
        label: "구분",
        value: "작업구분",
        query: { s2: "select" },
        options: {
          items: ["전체", "일반보수", "돌발보수", "기타"],
          default: "",
        },
      },
      {
        component: "search-select",
        label: "안전확인여부",
        value: "안전확인여부",
        query: { s3: "select" },
        options: {
          items: ["전체", "Y", "N"],
          default: "",
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "상태", "등록인원", "출입문 인원<br>(입문/출문)", "작업시작일", "시작시간", "종료시간", "TBM 여부", "승인권자<br/>(관리감독자)", "작업장소", "허가번호", "확인<br/>(안환팀)", "연장작업"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    if (search.사업장명) {
      conditions.push({
        key: "body.stdInfo.field_name",
        value: `%${search.사업장명}%`,
        operator: "LIKE",
      });
    }

    //  일자
    // 목록에 오늘 날짜만 보이기 위해서 default 값을 오늘 날짜로 설정하려고 했으나,
    // 오늘날짜부터 혹은 이전 날짜만 보이게 처리하기위해 default 값을 빈값으로 설정하고,
    // 검색하는 부분에서 default 날짜 처리
    if (!search.date.startDate && !search.date.endDate) {
      conditions.push({key: 'body.작업허가.작업시작일시', operator: '>=', value: new Date().format("yyyy-MM-dd")})
      conditions.push({key: 'body.작업허가.작업시작일시', operator: '<', value: new Date().addDays(1).format("yyyy-MM-dd")})
    } else {

      if (search.date.startDate) {
        conditions.push({key: 'body.작업허가.작업시작일시', operator: '>=', value: search.date.startDate})
      }
      if (search.date.endDate) {
        conditions.push({key: 'body.작업허가.작업시작일시', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
      }
    }

    // 허가번호
    if (search.허가번호) {
      conditions.push({
        key: "body.작업정보.허가번호",
        value: `%${search.허가번호}%`,
        operator: "LIKE",
      });
    }

    // 진행상태 상태: 1~5
    if (search.상태 && search.상태 !== "전체") {
      const searchValue = steps.indexOf(search.상태);
      conditions.push({ key: "body.상태", operator: "=", value: searchValue });
    }

    // 구분
    if (search.작업구분 && search.작업구분 !== "전체") {
      conditions.push({ key: "body.작업구분", operator: "=", value: search.작업구분 });
    }

    // 안전확인여부
    if (search.안전확인여부 && search.안전확인여부 === "Y") {
      conditions.push({ key: "body.안전관계자.확인자유무", operator: "=", value: "y" });
    } else if (search.안전확인여부 && search.안전확인여부 === "N") {
      conditions.push({ key: "body.안전관계자.확인자유무", operator: "=n", value: "n" });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }

    return conditions;
  },

  // =================================================================================================================
  getHead: () => {
    return [
      {
        name: "사업장명",
        key: "body.stdInfo.field_name",
      },
      {
        name: "상태",
        key: "body.상태",
        style: { minWidth: "120px" },
      },
      {
        name: "등록인원",
        key: "",
      },
      {
        name: "출입문 인원<br>(입문/출문)",
        key: "",
        style: { minWidth: "100px" },
      },
      {
        name: "작업시작일",
        key: "body.작업허가.작업시작일시",
      },
      {
        name: "시작시간",
        key: "body.작업허가.작업시간.시작",
      },
      {
        name: "종료시간",
        key: "body.작업허가.작업시간.종료",
      },
      {
        name: "구분",
        key: "body.작업구분",
      },
      {
        name: "업체명",
        key: "body.작업정보.업체명",
      },
      {
        name: "작업허가명",
        key: "body.작업정보.작업허가명",
      },
      {
        name: "허가번호",
        key: "body.작업정보.허가번호",
      },
      {
        name: "승인권자<br/>(관리감독자)",
        key: "body.작업허가.작업승인.승인자.성명",
        style: { whiteSpace: "nowrap" },
      },
      {
        name: "작업장소",
        key: "body.작업정보.작업장소",
      },
      {
        name: "작업내용",
        key: "body.작업정보.작업내용",
      },
      {
        name: "장비유형",
        key: "body.장비유형.선택[%]",
      },
      {
        name: "확인<br/>(안환팀)",
        key: "body.안전관계자.확인자유무",
        style: { whiteSpace: "nowrap" },
      },
      {
        name: "작성자",
        key: "body.stdInfo.writer_name",
      },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 사업장명
      case 1: {
        // 상태
        const 상태 = func.getContent(value).상태;
        return { type: "colorBox", color: stepsColor[상태], text: steps[상태] };
      }
      case 2:
        return func.getContent(value).users.length; // 등록인원;
      case 3: {
        const 상태 = func.getContent(value).상태;
        const users = getUsers(value);
        const 입문 = users.filter((user) => user.입문시간).length;
        const 출문 = users.filter((user) => user.출문시간).length;
        let color = "#3c3c3c";
        if (상태 === steps.indexOf("작업완료")) {
          if (출문 > 0 && 입문 === 출문) {
            color = "#28C76F";
          } else {
            color = "#EA5455";
          }
        }
        return { type: "html", html: `<span style="font-weight: bold; color:${color}">${입문}/${출문}</span>` };
      }
      case 4:
        return func.getContent(value).작업허가.작업시작일시; // 작업시작일시
      case 5:
        return func.getContent(value).작업허가.작업시간.시작; // 시작시간
      case 6:
        return func.getContent(value).작업허가.작업시간.종료; // 종료시간
      case 7:
        return func.getContent(value).작업구분; // 구분
      case 8:
        return func.getContent(value).작업정보.업체명.com_name; // 업체명
      case 9:
        return func.getContent(value).작업정보.작업허가명; // 작업허가명
      case 10:
        return func.getContent(value).작업정보.허가번호; // 허가번호
      case 11: {
        const 작업승인 = func.getContent(value).작업허가.작업승인;
        const 연장승인 = func.getContent(value).작업허가.연장승인;
        const 작업종료 = func.getContent(value).작업허가.작업종료;
        const 작업승인자 = [];
        if (작업승인.상태 === "승인") 작업승인자.push(작업승인.승인자.성명);
        if (연장승인.상태 === "승인") 작업승인자.push(연장승인.승인자.성명);
        if (작업종료.상태 === "승인") 작업승인자.push(작업종료.승인자.성명);

        return [...new Set(작업승인자)].join(", ");
      } // 승인권자(관리감독자)
      case 12: {
        const form = func.getContent(value);
        return `${form.작업정보.작업구역.region.name} ${form.작업정보.작업구역.zone.name}`; // 작업장소
      }
      case 13:
        return func.getContent(value).작업정보.작업내용; // 작업내용
      case 14:
        return func.getContent(value).장비유형.선택.join(", "); // 장비유형
      case 15:
        return `${func.getContent(value).안전관계자.확인자유무}`.toUpperCase(); // 확인(안환팀)
      case 16:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
};
export default list;
